module.exports = __webpack_public_path__ + "static/media/Vorstand2025.5b8cc6b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Vorstand2025.png
// module id = 33
// module chunks = 0